import Endpoint from "../../services/api/endpoint";
import { IBrand } from "../../utils/types/models";
import { createEntityReducer } from "./entityReducer";

export default createEntityReducer<IBrand>(Endpoint.Brands, Endpoint.BrandsList);